import { CompanyAddressWithContact, ICompanyAddress, ICompanyAddressWithContact, IContactPerson } from '@lib/address';
import { DeliveryReceiptItem, IDeliveryReceiptItem } from './IDeliveryReceiptItem';
import { IFileResponse } from '@lib/core';
import { MatDialog } from '@angular/material/dialog';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { SortingService } from '@lib/util';
import { Gender } from '@lib/user';

export interface IDeliveryReceiptViewResponse {
    data: IDeliveryReceipt;
    possibleActions: DeliveryReceiptPossibleActionType[];
}

export enum DeliveryReceiptPossibleActionType {
    WAREHOUSE_ADD = 'WAREHOUSE_ADD',
    CREATE_INVOICE = 'CREATE_INVOICE',
}

export interface IDeliveryReceipt {
    id: number;
    number: string;
    supplier: IDelvieryReceiptSupplier;
    shippingAddress: ICompanyAddressWithContact;
    deliveryDate: string;
    createDate: string;
    companyCodeId?: string | null;
    invoiceId: string;
    invoiceNumber: string;
    open: boolean;
    inApproval: boolean;
    comment: string;
    files: IFileResponse[];
    items: IDeliveryReceiptItem[];
    relations: IDeliveryReceiptRelations;
}

export interface IDeliveryReceiptRelations {
    invoice: IDeliveryReceiptDetailInvoiceRelationDto;
    orderRelations: IDeliveryReceiptDetailOrderRelationViewDto[];
    relatedDeliveryReceipts: IDeliveryReceiptDetailRelatedReceiptViewDto[];
}

export interface IDeliveryReceiptDetailOrderRelationViewDto {
    orderNumber: string;
    customerOrderNumber: string;
    supplierOrderNumber: string;
    orderDate: string;
    status: number;
    supplierCompanyName: string;
}

export interface IDeliveryReceiptDetailRelatedReceiptViewDto {
    id: number;
    receiptNumber: string;
    date: string;
    createDate: string;
    comment: string;
    open: boolean;
}

export interface IDeliveryReceiptDetailInvoiceRelationDto {
    id: string;
    invoiceDate: string;
    createdDate: string;
    invoiceNumber: string;
    messageToBuyer: string;
    status: string; // this is the invoice status enum
}

export interface IOrderContact extends IContactPerson {
    firstName: string;
    surName: string;
    email: string;
    phoneNumber: string;
    gender: Gender;
    title: string;
}

export interface IDelvieryReceiptSupplier {
    supplierId: string;
    supplierNumber?: string | null;
    companyAddress: ICompanyAddress;
    contacts: ISupplierContactViewDto[];
}

export interface ISupplierContactViewDto {
    firstName: string;
    surName: string;
    email: string;
    phoneNumber: string;
    gender: string;
    title: string;
}

export class DeliveryReceipt implements IDeliveryReceipt {
    createDate: string;
    deliveryDate: string;
    id: number;
    invoiceId: string;
    invoiceNumber: string;
    companyCodeId?: string | null;
    open: boolean;
    inApproval: boolean;
    items: DeliveryReceiptItem[];
    number: string;
    shippingAddress: CompanyAddressWithContact;
    supplier: IDelvieryReceiptSupplier;
    relations: IDeliveryReceiptRelations;
    files: IFileResponse[];
    comment: string;

    constructor(dto: IDeliveryReceipt, dialog: MatDialog, barcodeScanner: BarcodeScanner) {
        this.createDate = dto.createDate;
        this.deliveryDate = dto.deliveryDate;
        this.id = dto.id;
        this.invoiceId = dto.invoiceId;
        this.invoiceNumber = dto.invoiceNumber;
        this.companyCodeId = dto.companyCodeId;
        this.open = dto.open;
        this.inApproval = dto.inApproval;
        const items = dto.items.map((dto) => new DeliveryReceiptItem(dto, this.id, dialog, barcodeScanner));
        this.items = SortingService.sort(items, (item) => item.positionReceipt);
        this.number = dto.number;
        this.shippingAddress = CompanyAddressWithContact.fromInterface(dto.shippingAddress);
        this.supplier = dto.supplier;
        this.comment = dto.comment;
        this.files = dto.files;
        this.relations = dto.relations;
    }
}

export enum InvoiceStatus {
    DRAFT = 'DRAFT',
    CREATED = 'CREATED',
    UNAPPROVED = 'UNAPPROVED',
    APPROVED = 'APPROVED',
    CANCELED = 'CANCELED',
    REJECTED = 'REJECTED',
    PAID = 'PAID',
}
